import { MouseEvent, useState } from "react";
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";
import { ContentCopyRounded, DeleteOutlineRounded, DescriptionOutlined, EditOutlined, MoreVertRounded, VisibilityOutlined } from "@mui/icons-material";

import { HistoryConsultation } from "../history-filters";

// ----------------------------------------------------------------------

interface ConsultationActionsProps {
  item: HistoryConsultation;
  onPreview: (item: HistoryConsultation) => void;
  onRecipe: (item: HistoryConsultation) => void;
  onEdit: (item: HistoryConsultation) => void;
  onDuplicate: (item: HistoryConsultation) => void;
  onDelete: (item: HistoryConsultation) => void;
}

export default function ConsultationActions({ item, onPreview, onRecipe, onEdit, onDuplicate, onDelete }: ConsultationActionsProps) {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const stop = (event: MouseEvent) => event.stopPropagation();

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.5 }} onClick={stop}>
      <Tooltip title="Visualizar" placement="top">
        <IconButton aria-label="Visualizar consulta" onClick={() => onPreview(item)} sx={{ width: 32, height: 32, borderRadius: "9px", color: "text.secondary" }}>
          <VisibilityOutlined sx={{ fontSize: 17 }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Baixar receita" placement="top">
        <IconButton aria-label="Baixar receita" onClick={() => onRecipe(item)} sx={{ width: 32, height: 32, borderRadius: "9px", color: "text.secondary" }}>
          <DescriptionOutlined sx={{ fontSize: 17 }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Mais ações" placement="top">
        <IconButton aria-label="Mais ações" onClick={(event) => setAnchor(event.currentTarget)} sx={{ width: 32, height: 32, borderRadius: "9px", color: "text.secondary" }}>
          <MoreVertRounded sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        <MenuItem
          onClick={() => {
            setAnchor(null);
            onEdit(item);
          }}
        >
          <ListItemIcon>
            <EditOutlined sx={{ fontSize: 18 }} />
          </ListItemIcon>
          <ListItemText>Editar</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchor(null);
            onDuplicate(item);
          }}
        >
          <ListItemIcon>
            <ContentCopyRounded sx={{ fontSize: 18 }} />
          </ListItemIcon>
          <ListItemText>Duplicar</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchor(null);
            onDelete(item);
          }}
        >
          <ListItemIcon>
            <DeleteOutlineRounded sx={{ fontSize: 18, color: "error.main" }} />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>Excluir</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
}
